import React, { useState } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import logo from './logo.png';

// ✅ UPDATED IMPORT
import VisitorPage from './VisitorPage';

import NewForm from './NewForm';
import Renewal from './Renewal';
import NomineeAdd from './NomineeAdd';
import Claim from './Claim';
import Appointment from './Appointment';

function Home({ user, onLogout }) {
  const [active, setActive] = useState('Solar Form');

  return (
    <Box
      sx={{
        minHeight: '100vh',
        fontFamily: "'Segoe UI', sans-serif",
        background: '#f5f7fb',
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '100%',
          mx: 0,
          px: 0,
          py: { xs: 1, sm: 2 },
          boxSizing: 'border-box',
        }}
      >
        {/* HEADER */}
        <Paper
          sx={{ display: 'flex', gap: 2, alignItems: 'center', p: 2, mb: 2 }}
          elevation={3}
        >
          <Box component="img" src={logo} alt="Logo" sx={{ width: 72 }} />
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              variant="h5"
              sx={{ color: '#0b4a6f', fontWeight: 700 }}
            >
              BOCW Visitor Management
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, color: '#333' }}
            >
              Welcome, {user?.namename || 'User'} ({user?.user_role})
            </Typography>
            <Button variant="outlined" color="error" onClick={onLogout}>
              Logout
            </Button>
          </Box>
        </Paper>

        {/* NAV BUTTONS */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            backgroundColor: '#E65100',
          }}
        >
          <Button
            onClick={() => setActive('Solar Form')}
            sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}
          >
            Solar Form
          </Button>
          <Button
            onClick={() => setActive('New Form')}
            sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}
          >
            New Form
          </Button>
          <Button
            onClick={() => setActive('Renew')}
            sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}
          >
            Renew
          </Button>
          <Button
            onClick={() => setActive('Claim')}
            sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}
          >
            Claim
          </Button>
          <Button
            onClick={() => setActive('Add Nominee')}
            sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}
          >
            Add Nominee
          </Button>
          <Button
            onClick={() => setActive('Appointment')}
            sx={{ color: '#fff', fontWeight: 600, p: 1.5 }}
          >
            Appointment
          </Button>
        </Box>

        {/* MAIN CONTENT */}
        <Box sx={{ mt: 2 }}>
          {active === 'Solar Form' ? (
            // ✅ UPDATED COMPONENT USAGE
            <VisitorPage userid={user?.userid} />
          ) : active === 'New Form' ? (
            <NewForm userid={user?.userid} />
          ) : active === 'Renew' ? (
            <Renewal userid={user?.userid} />
          ) : active === 'Claim' ? (
            <Claim userid={user?.userid} />
          ) : active === 'Add Nominee' ? (
            <NomineeAdd userid={user?.userid} />
          ) : active === 'Appointment' ? (
            <Appointment userid={user?.userid} />
          ) : (
            <Paper sx={{ p: 4 }}>
              <Typography variant="h6">{active}</Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                This section is reserved for the "{active}" feature.
              </Typography>
            </Paper>
          )}
        </Box>

        {/* FOOTER */}
        <Box sx={{ mt: 4, pb: 2, textAlign: 'center' }}>
          <Typography
            variant="body2"
            sx={{ color: '#666', fontWeight: 500 }}
          >
            Software Developed by e.Sense InfoSolutions | Support: 9921946393
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default Home;
